import { Action } from '@ngrx/store';
import { ProductGroup } from '../../../models/product-group.model';

export enum ActionType {

  ADD_PRODUCTGROUP = 'ADD_PRODUCTGROUP',
  ADD_PRODUCTGROUP_SUCCESS = 'ADD_PRODUCTGROUP SUCCESS',
  ADD_PRODUCTGROUP_FAILED = 'ADD_PRODUCTGROUP FAILED',
  DELETE_PRODUCTGROUP = 'DELETE_PRODUCTGROUP',
  DELETE_PRODUCTGROUP_SUCCESS = 'DELETE_PRODUCTGROUP SUCCESS',
  DELETE_PRODUCTGROUP_FAILED = 'DELETE_PRODUCTGROUP FAILED',
  FETCH_PRODUCTGROUPS = 'FETCH PRODUCTGROUPS',
  FETCH_PRODUCTGROUPS_SUCCESS = 'FETCH PRODUCTGROUPS SUCCESS',
  FETCH_PRODUCTGROUPS_FAILED = 'FETCH PRODUCTGROUPS FAILED',
  UPDATE_PRODUCTGROUP = 'UPDATE PRODUCTGROUP',
  UPDATE_PRODUCTGROUP_SUCCESS = 'UPDATE PRODUCTGROUP SUCCESS',
  UPDATE_PRODUCTGROUP_FAILED = 'UPDATE PRODUCTGROUP FAILED',
  FETCH_PRODUCTGROUPS_BY_COMPANYID = 'FETCH PRODUCTGROUPS BY COMPANYID',
  FETCH_PRODUCTGROUPS_BY_COMPANYID_SUCCESS = 'FETCH PRODUCTGROUPS BY COMPANYID SUCCESS',
  FETCH_PRODUCTGROUPS_BY_COMPANYID_FAILED = 'FETCH PRODUCTGROUPS BY COMPANYID FAILED',
  DESTROY_PRODUCTGROUP = 'DESTROY_PRODUCTGROUP',
  DESTROY_PRODUCTGROUP_SUCCESS = 'DESTROY_PRODUCTGROUP SUCCESS',
  DESTROY_PRODUCTGROUP_FAILED = 'DESTROY_PRODUCTGROUP FAILED',
  FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID = 'FETCH PRODUCTGROUPS BY COMPANYIDSITEID',
  FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID_SUCCESS = 'FETCH PRODUCTGROUPS BY COMPANYIDSITEID SUCCESS',
  FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID_FAILED = 'FETCH PRODUCTGROUPS BY COMPANYIDSITEID FAILED',
}

export class DestroyProductGroup implements Action {
  readonly type = ActionType.DELETE_PRODUCTGROUP;

  constructor(public id: string) { }
}

export class DestroyProductGroupSuccess implements Action {
  readonly type = ActionType.DELETE_PRODUCTGROUP_SUCCESS;

  constructor(public id: string) { }
}

export class DestroyProductGroupFailed implements Action {
  readonly type = ActionType.DELETE_PRODUCTGROUP_FAILED;

  constructor() { }
}

export class FetchProductGroupsByCompanyIdSiteId implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID;
  constructor(public companyId: string, public siteId: string) { }
}

export class FetchProductGroupsByCompanyIdSiteIdSuccess implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID_SUCCESS;
  constructor(public productGroups: ProductGroup[]) { }
}

export class FetchProductGroupsByCompanyIdSiteIdFailed implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYIDSITEID_FAILED;
  constructor(public error: any) { }
}






export class FetchProductGroupsByCompanyId implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYID;
  constructor(public companyId: string) { }
}

export class FetchProductGroupsByCompanyIdSuccess implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYID_SUCCESS;
  constructor(public productGroups: ProductGroup[]) { }
}

export class FetchProductGroupsByCompanyIdFailed implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_BY_COMPANYID_FAILED;
  constructor(public error: any) { }
}

export class FetchProductGroups implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS;
  constructor() { }
}

export class FetchProductGroupsSuccess implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_SUCCESS;
  constructor(public productGroups: ProductGroup[]) { }
}

export class FetchProductGroupsFailed implements Action {
  readonly type = ActionType.FETCH_PRODUCTGROUPS_FAILED;
  constructor(public error: any) { }
}

export class AddProductGroup implements Action {
  readonly type = ActionType.ADD_PRODUCTGROUP;

  constructor(public productGroup: ProductGroup) { console.log('productGroup', productGroup); }
}

export class AddProductGroupSuccess implements Action {
  readonly type = ActionType.ADD_PRODUCTGROUP_SUCCESS;

  constructor(public productGroup: ProductGroup) { }
}

export class AddProductGroupFailed implements Action {
  readonly type = ActionType.ADD_PRODUCTGROUP_FAILED;

  constructor() { }
}

export class DeleteProductGroup implements Action {
  readonly type = ActionType.DELETE_PRODUCTGROUP;

  constructor(public id: string) { }
}

export class DeleteProductGroupSuccess implements Action {
  readonly type = ActionType.DELETE_PRODUCTGROUP_SUCCESS;

  constructor(public id: string) { }
}

export class DeleteProductGroupFailed implements Action {
  readonly type = ActionType.DELETE_PRODUCTGROUP_FAILED;

  constructor() { }
}

export class UpdateProductGroup implements Action {
  readonly type = ActionType.UPDATE_PRODUCTGROUP;

  constructor(public productGroup: ProductGroup) { }
}

export class UpdateProductGroupSuccess implements Action {
  readonly type = ActionType.UPDATE_PRODUCTGROUP_SUCCESS;

  constructor(
    public id: string,
    public changes: Partial<ProductGroup>,
  ) { console.log('changes', changes); }
}

export class UpdateProductGroupFailed implements Action {
  readonly type = ActionType.UPDATE_PRODUCTGROUP_FAILED;

  constructor() { }
}

export type ProductGroupActions =
  AddProductGroup | AddProductGroupFailed | AddProductGroupSuccess |
  UpdateProductGroup | UpdateProductGroupSuccess | UpdateProductGroupFailed |
  DeleteProductGroup | DeleteProductGroupSuccess | DeleteProductGroupFailed |
  FetchProductGroups | FetchProductGroupsSuccess | FetchProductGroupsFailed |
  FetchProductGroupsByCompanyId | FetchProductGroupsByCompanyIdSuccess | FetchProductGroupsByCompanyIdFailed |
  FetchProductGroupsByCompanyIdSiteId | FetchProductGroupsByCompanyIdSiteIdSuccess | FetchProductGroupsByCompanyIdSiteIdFailed |
  DestroyProductGroup | DestroyProductGroupSuccess | DestroyProductGroupFailed
  ;



